import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getOpsColor } from "../../../../utils/helper";
import {
  PACAccident,
  PACBlockingObject,
  PACConstruction,
  PACFire,
  PACFlood,
  PACGathering,
  PACLandslide,
  PACOther,
  PACRoadDamage,
  PACStuckVehicle,
  SVGIcon,
} from "../../../Icons/ReportTypes-icons";
import { CategoriesCard } from "../Reports-styled";

const ReportsCategories = [
  {
    id: 8,
    title: "Road Damage",
    key: "roadDamage",
    icon: PACRoadDamage,
  },
  {
    id: 1,
    title: "Landslide",
    key: "landslide",
    icon: PACLandslide,
  },
  {
    id: 2,
    title: "Flood",
    key: "flood",
    icon: PACFlood,
  },
  {
    id: 3,
    title: "Fire",
    key: "fire",
    icon: PACFire,
  },
  {
    id: 4,
    title: "Blocking Object",
    key: "blockingObjects",
    icon: PACBlockingObject,
  },
  {
    id: 5,
    title: "Accident",
    key: "accident",
    icon: PACAccident,
  },
  {
    id: 6,
    title: "Stuck Vehicle",
    key: "stuckVehicle",
    icon: PACStuckVehicle,
  },
  {
    id: 9,
    title: "Gathering",
    key: "gathering",
    icon: PACGathering,
  },
  {
    id: 7,
    title: "Construction",
    key: "construction",
    icon: PACConstruction,
  },
  {
    id: 10,
    title: "Other",
    key: "other",
    icon: PACOther,
  },
];

const PacType = ({ form, setForm, config, goNext, t }) => {
  const activeModule = useSelector((state) => state.activeModule);
  const onSelect = (value) => {
    setForm((form) => ({ ...form, pactype: value }));
    if (goNext) {
      goNext();
    }
  };
  const opsColor = useMemo(
    () => getOpsColor(config, activeModule),
    [config, activeModule]
  );

  return ReportsCategories.map((category) => (
    <CategoriesCard
      key={category.id}
      selected={form.pactype === category.id}
      className={form.pactype === category.id ? "blink_me" : ""}
      onClick={() => onSelect(category.id)}
      borderColor={opsColor}
      bgColor={form.pactype === category.id && opsColor ? `${opsColor}1a` : ""}
    >
      <SVGIcon color={opsColor} iconName={category.title} />
      <span>
        {t("report.pac.pages.pacType.typeOfAccessConstraint." + category.key)}
      </span>
    </CategoriesCard>
  ));
};

export default PacType;
